(() => {
  const render = () => {
    document.querySelectorAll('.shopify-policy__body p').forEach(node => { if (node.textContent.trim() === 'See the current expected arrival dates on the product page.') node.setAttribute('data-est-arrival', ''); });
    const parts = new Intl.DateTimeFormat('en-US', {timeZone:'America/New_York',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date());
    const part = type => Number(parts.find(p => p.type === type).value);
    const start = new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
    const addWeekdays = count => { const date = new Date(start); while (count) { date.setUTCDate(date.getUTCDate() + 1); if (![0, 6].includes(date.getUTCDay())) count--; } return date; };
    const format = date => new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month:'short',day:'numeric',timeZone:'UTC'}).format(date);
    for (const node of document.querySelectorAll('[data-est-arrival]')) node.textContent = `Expected by ${format(addWeekdays(4))} – ${format(addWeekdays(8))}`;
  };
  render();
  document.addEventListener('shopify:section:load', render);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) render(); });
})();

